<nav class="no-select" aria-label="Page navigation" *ngIf="total && (total > perPage)">
  <br>

  <ul class="pagination justify-content-center">
    <li class="page-item" *ngIf="current !== 1">
      <a class="page-link" (click)="goToPreviousPage()">
        <ng-container *ngIf="showButtonsAsIcons">
          <fa-icon [icon]="faChevronLeft"></fa-icon>
        </ng-container>
        <ng-container *ngIf="!showButtonsAsIcons">
          <strong>Previous</strong>
        </ng-container>
      </a>
    </li>
    <ng-container *ngFor="let pageNumber of getPageNumberRange()">
      <li class="page-item" [ngClass]="{ 'active': current && current.toString() === pageNumber }">
        <a class="page-link" (click)="goToPage(pageNumber)" *ngIf="pageNumber !== '...'">
          {{ pageNumber }}
        </a>
        <a class="page-link" (click)="promptForPageNumber()" *ngIf="pageNumber === '...'">
          {{ pageNumber }}
        </a>
      </li>
    </ng-container>
    <li class="page-item" *ngIf="current && (current < getPageCount())">
      <a class="page-link" (click)="goToNextPage()">
        <ng-container *ngIf="showButtonsAsIcons">
          <fa-icon [icon]="faChevronRight"></fa-icon>
        </ng-container>
        <ng-container *ngIf="!showButtonsAsIcons">
          <strong>Next</strong>
        </ng-container>
      </a>
    </li>
  </ul>

  <ng-container *ngIf="showStats">
    <hr>

    <p class="text-muted text-center small">
      <strong>{{ total | number }}</strong> records &nbsp;/&nbsp;
      <strong>{{ perPage | number }}</strong> per page &nbsp;/&nbsp;
      <strong>{{ getPageCount() | number }}</strong> pages
    </p>
  </ng-container>
</nav>
